import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import {
  getExperienceBasicInfo,
  getVariationNameById,
} from "@src/store/slices/experienceBuilder/common/selectors/getVisualBuilderTrackingContext";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { mpVisualBuilderModEditCancelled } from "@src/utils/mixpanel";
import { constructModificationPayload } from "@src/utils/mpUtils";

export interface TrackModEditCancelledPayload {
  mod: EmbeddedMod;
  hasUnsavedChanges: boolean;
}

export const trackModEditCancelled = createAsyncThunk<
  void,
  TrackModEditCancelledPayload
>("experienceBuilder/tracking/modEditCancelled", (payload, { getState }) => {
  const experienceInfo = getExperienceBasicInfo(getState());
  if (!experienceInfo) return;

  const { experienceId, experienceName, experienceType } = experienceInfo;
  const getVariationName = getVariationNameById(getState());
  const variationName = getVariationName(payload.mod.variationId);
  const modPayload = constructModificationPayload(payload.mod, variationName);
  const device = experienceBuilderSlice.selectors.getDevice(getState());

  mpVisualBuilderModEditCancelled({
    experienceId,
    experienceName,
    experienceType,
    ...modPayload,
    hasUnsavedChanges: payload.hasUnsavedChanges,
    builderMode: device,
  });
});
